import React from "react";

import { LeftOutlined } from "@ant-design/icons";
import { cx } from "class-variance-authority";

import { PaginationLink } from "./PaginationLink";

export function PaginationPrevious({
    className,
    "aria-label": ariaLabel = "Go to previous page",
    ...props
}: React.ComponentProps<typeof PaginationLink>) {
    return (
        <PaginationLink
            aria-label={ariaLabel}
            size="default"
            className={cx(className)}
            {...props}
        >
            <LeftOutlined />
        </PaginationLink>
    );
}
